import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Agent, AgentClient } from "src/app/web-api-client";

@Component({
  selector: 'app-agent-creation',
  templateUrl: './agent-creation.component.html',
  styleUrls: ['./agent-creation.component.scss']
})
export class AgentCreationComponent implements OnInit  {

  public isLoaded = true;
  public agents: Agent[];
  public onClose = new Subject<boolean>();
   Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,public client:AgentClient ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      agentName: ['', Validators.required],
      agentEIK: ['', Validators.required],
      defaultComission: [0.00, Validators.required],
      isActive: [null, Validators.required]
    });
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }
  onSubmit() {
    if (this.Form.valid) {

      let service =new Agent();

      service.idAgent = 0;
      service.agentName = this.Form.value.agentName;
      service.agentEIK = this.Form.value.agentEIK;
      service.defaultComission = this.Form.value.defaultComission;
      service.isActive = this.Form.value.isActive; 

      this.client.create(service).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}
